import * as React from 'react';
import { OfferAddedContainer } from '../offer_added/container';
import { OfferStatsContainer } from '../offer_stats/container';
import { OfferValueAddedServicesContainer } from '../offer_value_added_services/container';
import * as styles from './offerMeta.css';

interface IOfferMeta {
  isInHiddenBase: boolean | null;
}

export const OfferMeta = ({ isInHiddenBase }: IOfferMeta) => {
  return (
    <div className={styles['offer_meta_main']}>
      <div className={styles['offer_meta_main_left']}>
        <OfferAddedContainer />
        <OfferStatsContainer />
      </div>
      <div className={styles['offer_meta_main_right']}>
        <OfferValueAddedServicesContainer />
        {isInHiddenBase && <div className={styles['in_hidden_base']}>Видят только агенты</div>}
      </div>
    </div>
  );
};
